import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Field } from 'redux-form'
import { FormattedMessage } from 'react-intl'
import { FieldError } from 'components/misc'
import fieldId from 'constants/layout/fieldId'
import styles from './textarea.styl'

export default class Textarea extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    optional: PropTypes.bool,
    normalize: PropTypes.func,
    normalizeOnBlur: PropTypes.func,
    intlKey: PropTypes.string,
    onInputChange: PropTypes.func,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    maxLength: PropTypes.number,
    validate: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.arrayOf(PropTypes.func)
    ]),
    rows: PropTypes.number,
    placeHolder: PropTypes.string
  }

  static defaultProps = {
    normalize: null,
    rows: 3,
    validate: () => {}
  }

  handleChange = (e, field) => {
    if (this.props.onInputChange) {
      this.props.onInputChange(e.target.value)
    }
    field.input.onChange(e.target.value)
  }

  handleOnBlur = (e, field) => {
    if (this.props.normalizeOnBlur) {
      this.props.normalizeOnBlur(field)
    }
    field.input.onBlur()
  }

  renderField = field => {
    const { disabled, rows, placeHolder, maxLength } = this.props
    const { meta, input } = field

    const isError = meta.touched && meta.error
    const classNames = ['form-control', styles.formControl]

    isError && classNames.push('error')

    return (
      <div className={disabled ? styles.disabled : ''}>
        <textarea
          className={classNames.join(' ')}
          {...input}
          rows={rows}
          disabled={disabled}
          placeholder={placeHolder}
          maxLength={maxLength}
          onBlur={e => this.handleOnBlur(e, field)}
          onChange={e => this.handleChange(e, field)}
        />
        <FieldError toShow={isError} message={meta.error} />
      </div>
    )
  }

  render() {
    const { label, name, intlKey, disabled, optional } = this.props
    const classNames = ['control-label']

    disabled && classNames.push('control-label-disabled')
    return (
      <div className="form-group" id={`${fieldId}.${name}`}>
        <label htmlFor={name} className={classNames.join(' ')}>
          {intlKey
            ? <FormattedMessage id={intlKey} defaultMessage={label} />
            : label}
          {optional &&
            <span>
              {' '}(
              <FormattedMessage id="label.optional" defaultMessage="optional" />
              )
            </span>}
        </label>
        <Field
          {...this.props}
          id={name}
          name={name}
          component={this.renderField}
          normalize={this.props.normalize}
          validate={this.props.validate}
        />
      </div>
    )
  }
}
